import React, { useEffect } from "react";
import classNames from "classnames";
import { makeStyles } from "@mui/styles";
import Hidden from "@mui/material/Hidden";
import NavBar from "./Navbar";
import Sidebar, { drawerWidth } from "./Sidebar";
import GlobalPageSearch from "./GlobalPageSearch";
import { SearchProvider } from "contexts/SearchContext";
import sessionHelper from "services/sessionHelper";

const useStyles = makeStyles((theme) => ({
  content: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    maxWidth: "100vw",
    overflowX: "hidden",
    maxHeight: "100vh",
    overflow: "auto",
    boxSizing: "border-box",
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0,
    },
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: drawerWidth,
  },
}));

function AppShell({ children, actions = null }: any) {
  const classes = useStyles();

  const [open, setOpen] = React.useState(window.innerWidth > 768);
  const handleDrawerOpen = () => setOpen(!open);

  useEffect(() => {
    window.addEventListener("resize", () => setOpen(window.innerWidth > 768));

    // Check if password reset is required
    const userInfoStr = localStorage.getItem("userInfo");
    if (userInfoStr) {
      try {
        const userInfo = JSON.parse(userInfoStr);
        if (userInfo?.requiresPasswordReset) {
          // setUserEmail(userInfo.email);
          // setOpenResetPassword(true);
        }
      } catch (error) {
        console.error("Error parsing user info:", error);
      }
    }
  }, []);

  const userRole = sessionHelper.role;

  return (
    <SearchProvider>
      <Hidden smUp>
        <NavBar
          onToggleOpen={handleDrawerOpen}
          actions={actions}
          role={userRole}
        />
      </Hidden>
      <Sidebar open={open} onToggleOpen={handleDrawerOpen} role={userRole} />
      <main
        className={classNames({
          [classes.content]: true,
          [classes.contentShift]: open,
        })}
      >
        <Hidden smDown>
          <NavBar
            onToggleOpen={handleDrawerOpen}
            actions={actions}
            role={userRole}
          />
        </Hidden>
        {children}
      </main>
      <GlobalPageSearch />
    </SearchProvider>
  );
}

export default AppShell;
